import React, { useEffect, useRef, useState } from 'react';
import Colors from '../../constants/Colorsv2';
import moment from 'moment';
//Import redux actions
import { useDispatch, useSelector } from 'react-redux';

//Import Internal Components
import { View, ActivityIndicator, ScrollView, FlatList } from 'react-native';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { DirectMessageScreenProps } from '../../types';
import RichTextInput from '../Social/components/RichTextComponents/RichTextInput';
import DirectMessageHeader from './components/DirectMessageHeader';
import { social_getDirectGroup, social_getPlayerByPlayerId, social_saveMessage } from '../../store/actionsv1/social';
import { GroupMessageProps, GroupPlayerProps, GroupProps, RawDraftJSProps } from '../../store/types/soc_svc';
import { socket_joinChat, socket_leaveChat } from '../../store/actionsv1/socket';
import { message_getEmptyMessage, message_getUniqueDates } from './helpers/messages';
import MessageCard from './components/MessageCard';
import { Icon } from 'react-native-elements';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import RTIToolbar from './components/RichTextComponents/RTIToolbar';

const DirectMessageScreen = ({ route, navigation }: DirectMessageScreenProps) => {
    const [ loading, setLoading ] = useState(false);
    const [ toolbar_visible, setToolbarVisible ] = useState(false);
    const [ clear, setClear ] = useState(false);
    const [ draft_message, setDraftMessage ] = useState(message_getEmptyMessage())
    const [ uniqueDates, setUniqueDates ] = useState([moment().format('MMM DD')])
    
    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id === right?.player_id)
    const group:GroupProps|undefined = useSelector((state:any) => state.social.group, (left, right) => left?.group_id === right?.group_id)
    const group_players:GroupPlayerProps[] = useSelector((state:any) => state.social.group_players, (left, right) => left.length === right.length)
    const group_messages:GroupMessageProps[] = useSelector((state:any) => state.social.group_messages, (left, right) => left.length === right.length)
    const other_player:PublicPlayerProps|undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == route.params.other_id), (left, right) => left?.player_id == right?.player_id)

    useEffect(() => {
        if(!player || route.params.other_id === player.player_id){ return navigation.goBack() }
        getDirectGroupFromServer(player.player_id, route.params.other_id)
        return () => {
            dispatch(socket_leaveChat())
        }
    },[])

    useEffect(() => {
        if(!group){ return }
        dispatch(socket_joinChat(group.group_id))
    },[group])

    useEffect(() => {
        if(group_messages.length > 0){
            setUniqueDates(message_getUniqueDates(group_messages))
        }
    },[group_messages.length])

    const getDirectGroupFromServer = async(player_id:string, other_id:string) => {
        setLoading(true)
        await dispatch(social_getDirectGroup(player_id, other_id))
        await dispatch(social_getPlayerByPlayerId(other_id))
        setLoading(false)
    }

    const renderMessages = (data: { item:GroupMessageProps, index:number }) => {
            if(!data.item.group_message_id){ return (<></>) }
            let date = uniqueDates.find(d => d.message_index == data.index)
            let me = data.item.player_id == player?.player_id ? true: false
            return (
                <View style={{ marginBottom:20 }}>
                    {date?
                    <Text color={Colors.brand.slate} size={14} weight='regular' textAlign='center' style={{ marginBottom:6 }}>{date.date}</Text>
                    :<></>}
                    <MessageCard navigation={navigation} groupMessage={data.item} me_ind={me}/>
                </View>
            )
    }

    const handleImageUpload = async(image:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_images:[image], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleVideoUpload = async(video:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_videos:[video], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleOrderUpload = async(orders:string[]) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_orders:orders, group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleUrlUpload = async(url:string, url_preview:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_urls:[url], url_metadata:[url_preview], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }


    const handleSendMessage = async() => {
        if(loading || !player || !group){ return }
        if(!draft_message.message || draft_message.message === '' || !draft_message.formatted_body){ return alert('Message cannot be blank') }
        setLoading(true)
        await dispatch(social_saveMessage({ ...draft_message, group_id:group.group_id, player_id:player.player_id }))
        setClear(true)
        setDraftMessage(message_getEmptyMessage())
        setLoading(false)

    }

    const scrollView = useRef(null)

    const otherPlayer = group_players.find(cp => cp.player_id != player?.player_id)
    if(!otherPlayer) { 
        return (
            <View>
                <DirectMessageHeader navigation={navigation} playerDetails={other_player} active_ind={false}/>
                <ActivityIndicator size='large'/>
            </View>

        ) 
    }
    const format = 'hh:mm:ss'
    const start_time = moment('08:00:00', format)
    const end_time = moment('17:00:00', format)
    const live = route.params.other_id != '345' || moment().isBetween(start_time, end_time)
    return (
        <View style={{flex:1, backgroundColor:Colors.shades.white}}>
            <DirectMessageHeader navigation={navigation} playerDetails={other_player} active_ind={false}/>
            {!live ?
            <View style={{ padding:10, backgroundColor:Colors.highlights.highlight300 }}>
                <Text size={14} color={Colors.shades.white}>Live support is currently offline.  Questions will be addressed in the order they are received when an agent is available starting at 8:00 AM CST</Text>
            </View>
            :<></>}
            <ScrollView style={{ padding:10, opacity:live?1:0.5}} ref={scrollView} keyboardShouldPersistTaps='handled'
                onContentSizeChange={(contentWidth, contentHeight)=>{        
                    scrollView.current.scrollToEnd({animated: true});
                }}>
                     {loading ?
                    <View style={{ justifyContent:'center', alignItems:'center', padding:10 }}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight} />
                    </View>
                    :<></>}
                    <FlatList data={group_messages.sort((a,b) => moment(a.create_datetime).unix() - moment(b.create_datetime).unix())} renderItem={renderMessages} keyExtractor={(item, index) => item.group_message_id.toString()} extraData={[uniqueDates]}/>
            </ScrollView>
            {toolbar_visible ? 
            <RTIToolbar
                selected_orders={draft_message.message_orders}
                onTagOrders={(orders) => handleOrderUpload(orders)}
                onImageUpload={(image) => handleImageUpload(image)} 
                onVideoUpload={(video) => handleVideoUpload(video)} 
                onLinkCreate={(link, link_preview) => handleUrlUpload(link, link_preview)}
                onToolSelect={(tool) => console.log(tool)}
                />
            :<></>}
            <View style={{ flexDirection:'row', alignItems:'center', padding:10, backgroundColor: Colors.shades.white, shadowColor: "rgba(221, 221, 221, 0.6)", shadowOffset: { width: 0, height: -15 }, shadowRadius: 20, shadowOpacity: 1 }}>
                <TouchableOpacity style={{ height:42, width:42, justifyContent:'center', alignItems:'center', marginRight:5 }} onPress={() => setToolbarVisible(true)}>
                    <Icon name='plus' type='feather' color={Colors.brand.midnight} size={20} />
                </TouchableOpacity>
                <View style={{ flex:1, backgroundColor:Colors.shades.shade100, borderRadius:20, padding:10 }}>
                    <RichTextInput clear={clear} onClear={() => setClear(false)} placeholder='Start typing here' onUpdate={(formatted_body, message) => setDraftMessage({ ...draft_message, formatted_body, message })}/>
                </View>
                <TouchableOpacity style={{ height:42, width:42, backgroundColor:Colors.brand.midnight, borderRadius:100, justifyContent:'center', alignItems:'center', marginLeft:10 }} onPress={() => handleSendMessage()}>
                    <Icon name='send' type='feather' size={18} color={Colors.shades.white} />
                </TouchableOpacity>
            </View>
        </View>
    )
}

export default DirectMessageScreen